<style scoped>
.v-text-field > .v-input__control > .v-input__slot:after,
.v-text-field > .v-input__control > .v-input__slot:before {
  bottom: 9px !important;
}
</style>

<style>
.date-range > input {
  width: 80px !important;
}
.v-input__control > .v-input__slot > .v-text-field__slot > input[type='text'] {
  margin: 0 !important;
}
.fullheight {
  height: 100vh;
}

.custom-select {
  position: relative;
}

.custom-select .v-menu__content {
  top: 35px !important;
  left: 0 !important;
}

.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
</style>
<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        a Discount
  .row.fullheight
    .col.s12
      button.btn.mb-3(@click='showCreateDiscount()') ADD NEW
      v-card
        v-card-title
          v-layout.justify-space-between.align-center.wrap
            v-flex.sm7 Discount
            v-flex.sm5
              v-spacer
              v-text-field.custom-search(
                v-model='search',
                append-icon='search',
                label='Search',
                single-line='',
                hide-details=''
              )
        //- pre {{discountList}}
        v-card-text
          v-data-table(
            :headers='headers',
            :items='discountList',
            :search='search'
          )
            template(slot='items', slot-scope='props')
              td {{ props.item.name }}
              td {{ props.item.amount }}
              td {{ props.item.discountType }}
              td {{ props.item.description }}
              td {{ props.item.start | flterDate }}
              td {{ props.item.end | flterDate }}
              td.d-flex.align-center
                router-link.row.collection-item.ma-0(
                  :to='{ name: "discount-list", params: { pdList: props.item } }' title="Add Product or View all Discounted Products"
                )
                  i.material-icons.green-text add_task
                a.txt-red(@click.prevent='showUpdateDiscount(props.item)')
                  i.material-icons.red-text edit
                a.txt-red(@click.prevent='confirmDelete(props.item)')
                  i.material-icons.red-text delete
            v-alert(
              slot='no-results',
              :value='true',
              color='red',
              icon='warning'
            )
              | Your search for &quot;{{ search }}&quot; found no results.
</template>
<script>
import ModalCreateDiscount from '@/components/modal-discount-new'
import ModalUpdateDiscount from '@/components/modal-discount-update'
import moment from 'moment'
import DataTable from 'vue-materialize-datatable'
import AlertModalContent from 'inomph-common/dist/components/alert-modal-content'

export default {
  meta: {
    title: 'Discount'
  },
  data () {
    return {
      custombtn: [
        {
          hide: false,
          icon: 'add',
          onclick: this.showCreateDiscount
        }
      ],
      tableCol: [
        { label: 'Discount Name', field: 'name' },
        { label: 'Amount', field: 'amount' },
        { label: 'Details', field: 'description' },
        { label: 'From', field: 'start' },
        { label: 'To', field: 'end' }
      ],
      discountList: [],
      search: '',
      selected: [],
      pagination: {
        sortBy: 'name'
      },
      headers: [
        { text: 'Discount Name', value: 'name', align: 'left' },
        { text: 'Amount', value: 'amount', align: 'left' },
        { text: 'Type', value: 'discountType', align: 'left' },
        { text: 'Details', value: 'description', align: 'left' },
        { text: 'From', value: 'start', align: 'left' },
        { text: 'To', value: 'end', align: 'left' },
        { text: 'Action', value: '', align: 'left' }
      ]
    }
  },
  mounted () {
    this.$M.Collapsible.init(this.$refs.collapsible)
    this.getDiscountList()
  },
  methods: {
    showCreateDiscount () {
      const modalParams = {
        content: ModalCreateDiscount,
        bind: {
          onNewSuccess: (discount) => {
            this.discountList.push(discount)
            this.$snackbar.success('discount added')
            this.$store.dispatch('modal/close')
          },
          onNewFailed: (err) => {
            this.$snackbar.error(err.message)
          }
        },
        style: {
          padding: 'medium'
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    showUpdateDiscount (selecteddiscount) {
      const modalParams = {
        content: ModalUpdateDiscount,
        bind: {
          discountItem: selecteddiscount,
          onNewSuccess: (discount) => {
            // this.discountList.push(discount)
            this.$snackbar.success('discount updated')
            this.$store.dispatch('modal/close')
            this.getDiscountList()
          },
          onNewFailed: (err) => {
            this.$snackbar.error(err.message)
          }
        },
        style: {
          padding: 'medium'
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    confirmDelete (selecteddiscount) {
      const modalParams = {
        content: AlertModalContent,
        style: { padding: 'medium' },
        bind: {
          title: `Delete ${selecteddiscount.name} discount?`,
          message: 'This cannot be undone.',
          positiveButton: {
            message: 'Delete',
            onClick: this.deleteSelectedDiscount.bind(this, selecteddiscount)
          },
          negativeButton: {
            message: 'Cancel',
            onClick: () => {
              this.modal.close()
            }
          }
        }
      }

      this.$store.dispatch('modal/open', modalParams).then((modal) => {
        this.modal = modal
      })
    },

    deleteSelectedDiscount (disID) {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .delete(
            `${this.$config.API_URL}/suppliers/discount/delete/${disID.id}`,
            {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(() => {
            this.$snackbar.success('Discount deleted')
            this.getDiscountList()
          })
          .catch((err) => {
            this.$snackbar.error('Unable to delete Discount: ' + err.message)
          })
          .then(() => {
            this.getDiscountList()
            this.$store.dispatch('modal/close')
          })
      })
    },
    updateDiscount (selecteddiscount) {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .post(
            `${this.$config.API_URL}/suppliers/discount/update/${selecteddiscount.id}`,
            {
              type: selecteddiscount.discountType,
              name: selecteddiscount.name,
              description: selecteddiscount.description,
              amount: selecteddiscount.amount,
              start: selecteddiscount.start,
              end: selecteddiscount.end
            },
            {
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(() => {
            this.$snackbar.success('Discount updated')
            this.getDiscountList()
          })
          .catch((err) => {
            this.$snackbar.error('Unable to updated Discount: ' + err.message)
          })
          .then(() => {
            this.getDiscountList()
          })
      })
    },
    getDiscountList () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
          .get(`${this.$config.API_URL}/suppliers/discount/list`, {
            headers: {
              Authorization: 'Bearer ' + accessToken
            }
          })
          .then((result) => {
            this.discountList = result.data
          })
      })
    },
    onRowClick: function (row) {}
  },
  filters: {
    flterDate: function (date) {
      return moment(date).format('MMMM DD, YYYY')
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-discount.vue